export default {
  calendar: {
    title: 'Approver Calendar',
    requestTypes: 'Request type:',
    year: 'Year',
    month: 'Month',
    filterStatus: 'Filter status'
  },
  detail: {
    title: 'Time Request Detail',
    requester: 'Name - Surname',
    requestType: 'Request Type',
    date: 'Date',
    period: 'Time Duration',
    status: 'Status',
    approver: 'Approval Persons',
    reason: 'Reason',
    allowance: 'Special Allowance',
    value: 'Value',
    adjustTime: 'Adjust approved OT time',
    actionFailed: 'Unable to save your decision. Please try again.'
  },
  exportUi: {
    title: 'Export data',
    description:
      'Select an employee, report type and date range to export your data.',
    company: 'Company {{company}}',
    create: 'Create export',
    chooseData: 'Choose data',
    periodLanguage: 'Period & language',
    language: 'File language',
    hint: 'Exported files appear in the history below.',
    export: 'Export',
    history: 'Export history',
    fileCount: '{{count}} files',
    download: 'Download'
  },
  form: {
    start: {
      placeholder: 'Start',
      label: 'Start'
    },
    end: {
      placeholder: 'To',
      label: 'To'
    },
    status: {
      placeholder: 'Status',
      label: 'Status'
    },
    reqStart: {
      placeholder: 'Start time',
      label: 'Start time'
    },
    reqEnd: {
      placeholder: 'End time',
      label: 'End time'
    },
    timeIn: {
      placeholder: 'Start time',
      label: 'Start time'
    },
    timeOut: {
      placeholder: 'End time',
      label: 'End time'
    },
    date: {
      placeholder: 'Date',
      label: 'Date'
    },
    allowanceUseDate: {
      placeholder: 'Date',
      label: 'Date'
    },
    appEditTimeIn: {
      placeholder: 'Edit start time',
      label: 'Edit start time'
    },
    appEditTimeOut: {
      placeholder: 'Edit end time',
      label: 'Edit end time'
    },
    value: {
      placeholder: 'Insert special allowance value',
      label: 'Special allowance value'
    },
    reason: {
      placeholder: 'Insert request reason.',
      label: 'Reason'
    },
    allowanceCode: {
      placeholder: 'Select special allowance.',
      label: 'Special allowance'
    },
    employee_code: {
      placeholder: 'Delegator..',
      label: 'Delegator'
    },
    employee: {
      placeholder: 'Employee..',
      label: 'Employee'
    },
    EExportType: {
      placeholder: 'Export Type',
      label: 'Export Type'
    }
  },
  table: {
    status: 'Status',
    action: 'Action',
    date: 'Date',
    title: 'Title',
    remark: 'Remark',
    requester: 'Requester',
    createdAt: 'Date',
    fileName: 'File name',
    fileUuid: 'File uuid',
    url: 'Download'
  },
  modal: {
    approve: 'Are you sure want to Approve ?',
    reject: 'Are you sure want to Reject ?',
    approver: 'Approver'
  },
  buttons: {
    refresh: 'Refresh',
    export: 'Export'
  },
  exportJob: {
    queued: {
      title: 'Export queued',
      description: 'Your request is waiting to be processed.'
    },
    processing: {
      title: 'Preparing export',
      description: 'The file list will update automatically when it is ready.'
    },
    longRunning: {
      title: 'Export is taking longer than expected',
      description: 'You can leave this page and return in the same browser tab.'
    },
    failed: {
      title: 'Export failed',
      description: 'The file could not be created. Please try again.'
    },
    'tracking-error': {
      title: 'Unable to check export status',
      description: 'Use Refresh to check whether the file is available.'
    },
    success: 'Your export file is ready.',
    submitFailed: 'Unable to start the export. Please try again.'
  },
  radio: {
    en: 'EN',
    th: 'TH'
  },
  status: {
    'Wait work time': 'Waiting for work time transaction.',
    'Pending approve': 'Pending approve',
    'Pending cancel': 'Pending cancel',
    'Partial approve': 'Partial approve',
    'Partial preview': 'Partial preview',
    'Partial cancel': 'Partial cancel',
    Approve: 'Approve',
    Canceled: 'Canceled',
    Reject: 'Reject'
  },
  title: {
    OT: 'OT',
    'Special Allowance': 'Special Allowance',
    'Edit Time': 'Edit Time'
  }
}
